<alert type="{{ alertType }}" class="dashboard-page-alert" [dismissible]="true" *ngIf="alertVisible">
    <div class="container">{{ data.message }}</div>
</alert>